(function(angular) {
    'use strict';

    angular.module('aprima-core').filter('hasNoKeys', [
        'hasKeysFilter',
        hasNoKeysFactory,
    ]);

    function hasNoKeysFactory(
        hasKeys
    ) {

        return hasNoKeys;


        function hasNoKeys(input) {
            var result = !hasKeys(input);
            return result;
        }
    }

})(window.angular);